// extracted by mini-css-extract-plugin
export var cardHeader = "_ig-0";
export var reorderHandle = "_ig-3";
export var titleArea = "_ig-1";
export var titleAreaWithHandle = "_ig-2";